import React from 'react';
import { ShieldCheck, Clock } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function PriceBlock() {
  return <section id="price-section" className="w-full py-24 px-6 bg-white border-t border-beige" data-id="element-98">
      <div className="max-w-2xl mx-auto text-center" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 text-red-800 text-sm font-bold mb-8 border border-red-100" data-id="element-101">
            <Clock className="w-4 h-4" data-id="element-102" />
            <span className="uppercase tracking-wide" data-id="element-103">
              Oportunidad Única de Rescate
            </span>
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl text-dark-coffee font-semibold mb-6" data-id="element-104">
            Esta es tu oportunidad de protegerlo
          </h2>

          <div className="mb-8" data-id="element-105">
            <p className="text-soft-brown/70 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-106">
              Precio de lanzamiento — solo por tiempo limitado
            </p>
            <p className="text-soft-brown/60 line-through text-xl mb-2 font-playfair" data-id="element-107">
              $19.990 ARS
            </p>
            <p className="text-5xl md:text-6xl font-playfair font-bold text-dark-coffee" data-id="element-108">
              $8.990{' '}
              <span className="text-2xl text-soft-brown font-normal" data-id="element-109">ARS</span>
            </p>
            <p className="text-sm text-warm-accent font-medium mt-4" data-id="element-110">
              Único pago. Acceso inmediato de por vida. Sin suscripciones.
            </p>
          </div>

          <a href="https://tutiendadigi.shop/cart/51930891223320:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block w-full sm:w-auto bg-warm-accent hover:bg-[#8A4525] text-white font-bold py-5 px-10 rounded-full text-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-floating mb-6 animate-pulse-glow text-center" data-id="element-111">
            QUIERO PROTEGER A MI HIJO AHORA
          </a>

          {/* Guarantee inline next to button */}
          <div className="flex items-center justify-center gap-2 mb-12 text-soft-brown text-sm" data-id="element-112">
            <ShieldCheck className="w-5 h-5 text-warm-accent shrink-0" data-id="element-113" />
            <p data-id="element-114">
              Tu compra está protegida. Si no te sirve, te devolvemos el dinero.
            </p>
          </div>

          <div className="flex flex-col items-center gap-5 mb-12" data-id="element-115">
            {/* Payment Logos */}
            <div className="flex items-center justify-center gap-3 mt-2 bg-white py-5 px-6 rounded-2xl border border-beige" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/ovXQe5Bq8bc6vD6nhzdSwf/Captura_de_pantalla_8-4-2026_212350_www.google.com.jpg" alt="Visa" className="h-10 object-contain" data-id="element-117" />
              <div className="w-px h-10 bg-beige" data-id="element-118"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hyVwLBHxDkCSHmQW5NyMEW/Captura_de_pantalla_8-4-2026_211944_www.mercadopago.com.ar.jpg" alt="Mercado Pago" className="h-14 object-contain" data-id="element-119" />
              <div className="w-px h-10 bg-beige" data-id="element-120"></div>
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-10 object-contain" data-id="element-121" />
            </div>
          </div>

          {/* Guarantee Block */}
          <div className="max-w-md mx-auto bg-creme border border-beige rounded-2xl p-6 text-center shadow-sm" data-id="element-122">
            <div className="flex justify-center mb-4" data-id="element-123">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm" data-id="element-124">
                <ShieldCheck className="w-6 h-6 text-warm-accent" data-id="element-125" />
              </div>
            </div>
            <h3 className="font-playfair text-xl font-bold text-dark-coffee mb-2" data-id="element-126">
              Garantía de Satisfacción
            </h3>
            <p className="text-soft-brown text-sm leading-relaxed" data-id="element-127">
              Si en 7 días no sentís que tenés las herramientas para proteger a
              tu hijo, te devolvemos el 100% de tu dinero. Sin preguntas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}